var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_5190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.967 3.39896L12.7394 2.62656C14.0192 1.34681 16.0941 1.34681 17.3738 2.62656C18.6536 3.90632 18.6536 5.98121 17.3738 7.26096L16.6014 8.03336M11.967 3.39896C11.967 3.39896 12.0636 5.04031 13.5118 6.48856C14.9601 7.93681 16.6014 8.03336 16.6014 8.03336M11.967 3.39896L4.86601 10.5C4.38504 10.981 4.14456 11.2215 3.93774 11.4866C3.69377 11.7994 3.4846 12.1378 3.31394 12.4959C3.16927 12.7995 3.06172 13.1221 2.84663 13.7674L1.93517 16.5018M16.6014 8.03336L9.50041 15.1344C9.01944 15.6154 8.77896 15.8558 8.5138 16.0627C8.20101 16.3066 7.86257 16.5158 7.50447 16.6865C7.20091 16.8311 6.87826 16.9387 6.23298 17.1538L3.49859 18.0652M3.49859 18.0652L2.83019 18.288C2.51264 18.3939 2.16254 18.3112 1.92585 18.0746C1.68916 17.8379 1.60652 17.4878 1.71237 17.1702L1.93517 16.5018M3.49859 18.0652L1.93517 16.5018",
    stroke: "#0ABAB5",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_5190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.532fe60834b67511b856a4cf2dd3f2a6.svg";
export { ForwardRef as ReactComponent };